import React, { useRef, useState } from "react";
import { toast } from "react-toastify";
import { CSVLink } from "react-csv";
import { DealerService } from "../../../service";
import FidCsvSample from "../../../webroot/csv-sample/fid-category-sample.csv";

const CsvUploader = ({ onSuccess }) => {
    const fileInputRef = useRef(null);

    const [dragOver, setDragOver] = useState(false);
    const [loading, setLoading] = useState(false);
    const [fileName, setFileName] = useState("");
    const [invalidData, setInvalidData] = useState([]);
    const [errorText, setErrorText] = useState("");

    const openFilePicker = () => {
        fileInputRef.current?.click();
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        validateAndUpload(file);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setDragOver(false);

        const file = e.dataTransfer.files[0];
        if (!file) return;
        validateAndUpload(file);
    };

    const validateAndUpload = async (file) => {
        if (!file.name.toLowerCase().endsWith(".csv")) {
            toast.error("Only CSV files are allowed");
            return;
        }

        setFileName(file.name);
        uploadCsv(file);
    };

    const uploadCsv = async (file) => {
        try {
            setLoading(true);
            setInvalidData([]);
            setErrorText("");

            const formData = new FormData();
            formData.append("file", file);

            const response = await DealerService.uploadFidCategories(formData);

            if (response?.status === 200 && response?.data?.status === 200) {
                const responseData = response?.data?.data || {};
                const responseDetails = responseData?.data || {};
                const toasMesz = `${responseData?.message} Success - ${responseDetails?.valid_rows} , Failed - ${responseDetails?.invalid_rows}`;

                if (responseDetails.invalid_data?.length) {
                    setInvalidData(responseDetails.invalid_data);
                    setErrorText(
                        `Only ${responseDetails.invalid_data.length} records failed due to validation errors`
                    );
                    toast.success(toasMesz || "Some rows failed. Please download error file.");
                } else {
                    toast.success(toasMesz || "Upload successful");
                    onSuccess?.();
                }
            } else {
                toast.error("Internal Server Error");
            }
        } catch (error) {
            toast.error("Internal Server Error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="csv-uploader">
            <div
                className={`upload-box ${dragOver ? "drag-over" : ""}`}
                onClick={openFilePicker}
                onDrop={handleDrop}
                onDragOver={(e) => {
                    e.preventDefault();
                    setDragOver(true);
                }}
                onDragLeave={() => setDragOver(false)}
            >
                <div className="icon">
                    <i className="ic-file-icon" />
                </div>

                <h4>Drop files here to upload</h4>
                <p>Only .csv accepted</p>

                <span className="or">OR</span>

                <button
                    type="button"
                    className="browse-btn"
                    disabled={loading}
                >
                    {loading ? "Uploading..." : "Browse File"}
                </button>

                {fileName && <div className="file-name">{fileName}</div>}

                {errorText && (
                    <div className="upload-error-msg">
                        {/* <span>{errorText}</span> */}
                        <CSVLink
                            data={invalidData}
                            filename="invalid_fid_categories.csv"
                            className="download-link"
                            onClick={(e) => e.stopPropagation()}
                        >
                            Download Invalid Records
                        </CSVLink>
                    </div>
                )}
            </div>

            <div className="sample-csv-link">
                <a
                    href={FidCsvSample}
                    download
                    onClick={(e) => e.stopPropagation()}
                >
                    Click here to download sample CSV
                </a>
            </div>

            {/* Hidden Input */}
            <input
                type="file"
                ref={fileInputRef}
                className="hidden-input"
                accept=".csv"
                onChange={handleFileChange}
                disabled={loading}
            />
        </div>
    );
};

export default CsvUploader;
